import { Intl } from 'Roblox';
import supportModule from '../supportModule';

function ageGateController(
  $log,
  $q,
  $scope,
  supportService,
  modalService,
  languageResource,
  regexService,
  captchaV2Constants,
  resources,
  ageGateConstants
) {
  'ngInject';

  // ageGate

  $scope.ageGate = {};
  $scope.layout = {
    orderedBirthdayParts: {
      parts: ageGateConstants.defaultDateParts,
      typeOrder: ageGateConstants.defaultDateOrdering
    }
  };
  const intl = new Intl();

  function setMonthList() {
    $scope.layout.months = [
      { value: 'Jan', label: languageResource.get('Label.January') },
      { value: 'Feb', label: languageResource.get('Label.February') },
      { value: 'Mar', label: languageResource.get('Label.March') },
      { value: 'Apr', label: languageResource.get('Label.April') },
      { value: 'May', label: languageResource.get('Label.May') },
      { value: 'Jun', label: languageResource.get('Label.June') },
      { value: 'Jul', label: languageResource.get('Label.July') },
      { value: 'Aug', label: languageResource.get('Label.August') },
      { value: 'Sep', label: languageResource.get('Label.September') },
      { value: 'Oct', label: languageResource.get('Label.October') },
      { value: 'Nov', label: languageResource.get('Label.November') },
      { value: 'Dec', label: languageResource.get('Label.December') }
    ];
    const placeholder = 'MM';
    setOrderedBirthdayPart('month', $scope.layout.months, placeholder);
  }

  function setDateList() {
    const dates = [];
    const maximumDate = ageGateConstants.maxNumberOfDates;

    for (let i = 1; i <= maximumDate; i++) {
      // add leading zero (1 => 01 and 10 => 10)
      const day = `0${i}`.slice(-2);
      const i18nDay = {
        day,
        value: day,
        label: $scope.isAsianBirthdayUsed
          ? intl.getFormattedDateString(day, languageResource.get('Label.Day'))
          : day
      };
      dates.push(i18nDay);
    }

    $scope.layout.dates = dates;

    const placeholder = 'DD';
    setOrderedBirthdayPart('day', dates, placeholder);
  }

  function setYearList() {
    const years = [];
    const now = new Date();
    const currentYear = now.getFullYear();
    const minimumYear = currentYear - ageGateConstants.maxAgeGateAge;

    for (let i = currentYear; i > minimumYear; i--) {
      const i18nYear = {
        year: i,
        value: i,
        label: $scope.isAsianBirthdayUsed
          ? intl.getFormattedDateString(i, languageResource.get('Label.Year'))
          : i
      };
      years.push(i18nYear);
    }

    $scope.layout.years = years;

    const placeholder = 'YYYY';
    setOrderedBirthdayPart('year', years, placeholder);
  }

  function setOrderedBirthdayPart(partName, value, placeholder) {
    const partIndex = $scope.layout.orderedBirthdayParts.typeOrder[partName];

    $scope.layout.orderedBirthdayParts.parts[partIndex] = {
      options: value,
      idName: ageGateConstants.birthdayPicker[partName].id,
      className: ageGateConstants.birthdayPicker[partName].class,
      birthdayName: ageGateConstants.birthdayPicker[partName].name,
      placeholder
    };
  }

  // ageGate functions

  $scope.isBirthdayFormDirty = function () {
    // Birthday Form can only be dirty when it exists
    if (
      $scope.ageGateForm.birthdayMonth &&
      $scope.ageGateForm.birthdayDay &&
      $scope.ageGateForm.birthdayYear
    ) {
      return (
        $scope.ageGateForm.birthdayMonth.$dirty &&
        $scope.ageGateForm.birthdayDay.$dirty &&
        $scope.ageGateForm.birthdayYear.$dirty &&
        $scope.ageGateForm.birthdayMonth.$modelValue !== null &&
        $scope.ageGateForm.birthdayDay.$modelValue !== null &&
        $scope.ageGateForm.birthdayYear.$modelValue !== null
      );
    }
    return false;
  };

  $scope.isBirthdayInvalid = function () {
    return (
      ($scope.badAgeGateSubmit || $scope.isBirthdayFormDirty()) &&
      (!$scope.isValidBirthday($scope.ageGate.birthdayDay) ||
        $scope.ageGateForm.birthdayYear.$invalid)
    );
  };

  $scope.getBirthdayInvalidMessage = function () {
    return $scope.isBirthdayInvalid() ? languageResource.get('Response.InvalidBirthday') : '';
  };

  $scope.isValidBirthday = function (day, onlyValidateDay) {
    let year = $scope.ageGate.birthdayYear;

    if (!year && onlyValidateDay) {
      // set to non-leap year to be conservative when determining which days are available for the selected month
      year = ageGateConstants.nonLeapYear;
    }

    const month = $scope.ageGate.birthdayMonth;
    day = parseInt(day); // convert day to integer

    if (!year || !month || !day) {
      return false;
    }

    // Make sure we can create a valid date object
    const testDate = new Date(`${month} ${day} ${year}`);
    if (Object.prototype.toString.call(testDate) !== '[object Date]' || isNaN(testDate.getTime())) {
      return false;
    }

    // checks that it is actually a valid day in that month (like feb 31 doesn't exist but would generate a valid Date)
    if (testDate.getDate() !== day) {
      return false;
    }

    // age limits
    const today = new Date();
    const isBirthdayValid =
      testDate.getTime() < today.getTime() && testDate.getFullYear() > today.getFullYear() - 100;

    if (!isBirthdayValid) {
      return false;
    }

    return true;
  };

  $scope.isUnder13 = function () {
    const year = $scope.ageGate.birthdayYear;
    const month = $scope.ageGate.birthdayMonth;
    const day = $scope.ageGate.birthdayDay;

    if (!year || !month || !day) {
      return true;
    }

    const testDate = new Date(`${month} ${day} ${year}`);
    const u13ThresholdDate = new Date();
    u13ThresholdDate.setFullYear(u13ThresholdDate.getFullYear() - 13);
    return testDate > u13ThresholdDate;
  };

  // form functions
  $scope.isFormValid = function () {
    return $scope.ageGateForm.$valid;
  };

  $scope.submitAgeGate = function () {
    if (!$scope.isFormValid() || !$scope.isValidBirthday($scope.ageGate.birthdayDay)) {
      $scope.badAgeGateSubmit = true;
      return;
    }
    $scope.badAgeGateSubmit = false;

    let currentAge13AndOver = false;
    if (!$scope.isUnder13()) {
      $scope.$emit('onAgeGateAge13AndOverTrue');
      currentAge13AndOver = true;
    } else {
      $scope.$emit('onAgeGateAge13AndOverFalse');
    }
    const currentTime = new Date();
    // currentTime.setSeconds(currentTime.getSeconds()+10);//for testing
    currentTime.setHours(currentTime.getHours() + 2);
    const storageAge13AndOver = {
      expiresAt: currentTime,
      age13AndOver: currentAge13AndOver
    };
    localStorage.setItem('currentAge13AndOver', JSON.stringify(storageAge13AndOver));

    $scope.$emit('onAgeGateSubmitted');
  };

  $scope.init = function init() {
    $scope.badAgeGateSubmit = false;
    $scope.isAsianBirthdayUsed = intl && intl.isAsianLanguage();
    $scope.layout.orderedBirthdayParts.typeOrder = new Intl()
      .getDateTimeFormatter()
      .getOrderedDateParts();
    setMonthList();
    setDateList();
    setYearList();
  };

  $scope.init();
}

supportModule.controller('ageGateController', ageGateController);

export default ageGateController;
